import { useEffect, type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Space } from '@g2u/ui-kit';
import { Skeleton } from 'antd';

import { Greeting, BookingFlowSelection } from './components';
import { useBookingStartParams } from './hooks';
import { Content, Intro } from 'components';
import { BookingStore } from 'store';
import styles from './start.module.scss';

export const StartPage: FC = observer(() => {
  const { resetBookingProgress, setCustomer } = BookingStore;
  const { isCustomerLoading, customer } = useBookingStartParams();
  const navigate = useNavigate();

  useEffect(() => {
    resetBookingProgress();
    if (customer) {
      setCustomer(customer);
      navigate('/booking/location');
    }
  }, [customer]);

  return (
    <Content className={styles.start} dataTestId="start-page">
      <title>Start Booking</title>
      <Space.$ size={Space.Size.Large} direction={Space.Direction.Vertical} fullWidth>
        {isCustomerLoading ? (
          <Skeleton />
        ) : (
          <>
            <Intro />
            <Greeting />
            <BookingFlowSelection />
          </>
        )}
      </Space.$>
    </Content>
  );
});
